export default __webpack_public_path__ + "static/media/Check Mark.54f0d75c.svg";